import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class IWGSharedService {
    isMyRateDirty = false;
    isQuestionDirty = false;
    iwgUserLinkStatus = false;
    HasWorkerProfile: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    iwgfileuploadstatus: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    iwgfileattached: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    iwgfilefiledeleted: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    iwgfileattachedreset: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    AssignmentChange: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selecttoupdateeor: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    selecttoupdateaorcompliance: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    workertitlecontractor: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    workerselecttoupdateaorcompliance: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    workerselecttoupdateeor: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    iwgfileuploaded: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    resetPasswordProgress: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    isDialogOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    isStateChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    isBlurredBg: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    constructor() {}
    setMyRateDirty(myRateDirty: boolean) {
      this.isMyRateDirty = myRateDirty;
    }
    setAssignmentQuestionDirty(questionDirty: boolean) {
        this.isQuestionDirty = questionDirty;
    }

    getAssignmentQuestionDirty() {
        return this.isQuestionDirty;
    }
    setIWGUserLinkStatus (iwgUserLinkStatus: boolean) {
        this.iwgUserLinkStatus = iwgUserLinkStatus;
    }

    getMyRateDirty() {
      return this.isMyRateDirty;
    }

    getIWGUserLinkStatus() {
      return this.iwgUserLinkStatus;
    }

    getNavURL() {
        var URL = '';
        try {
            var arrFrames = parent.document.getElementsByTagName("IFRAME");
            console.log(arrFrames)           
            if (arrFrames != null && arrFrames.length > 0) {
                for (var frame = 0; frame <= 0; frame++) {
                    if (arrFrames[frame] != null) {
                        var i_outerHTML = arrFrames[frame].outerHTML;
                        console.log('i_outerHTML' + frame + ':  ' + i_outerHTML);
                        if (i_outerHTML && i_outerHTML.indexOf('/myGuides?embed=1') > 0) {
                            URL = 'myGuides'
                        } else if (i_outerHTML && i_outerHTML.indexOf('/vendor-invoices?embed=1') > 0) {
                            URL = 'vendor-invoices'
                        }
                    }    
                }
            }
            return URL;
        }
        catch (ex) {
            console.log('IFRAME' + ex);
        }
    }

    getIsEmbed() {   

        var dreferrer = document.referrer;
        var host = window.location.host
        if (dreferrer !== null && dreferrer !== "") {
            var url = document.referrer;
            var referrer = url.match(/:\/\/(.[^/]+)/)[1];
            console.log('host ' + host)
            console.log('referrer  ' + referrer)
            if (referrer !== host) {
                return true;
            }
        }

        try {
            var arrFrames = parent.document.getElementsByTagName("IFRAME");
            console.log(arrFrames)
            var isIframe = false;
            if (arrFrames != null && arrFrames.length > 0) {
                for (var frame = 0; frame <= 0; frame++) {
                    if (arrFrames[frame] != null) {
                        var i_outerHTML = arrFrames[frame].outerHTML;
                        console.log('i_outerHTML' + frame + ':  ' + i_outerHTML);
                        if (i_outerHTML && i_outerHTML.indexOf('/myGuides?embed=1') > 0) {
                            isIframe = true;
                            console.log('i_outerHTML has ' + '/myGuides?embed=1');
                        }
                        else if (i_outerHTML && i_outerHTML.indexOf('/vendor-invoices?embed=1') > 0) {
                            isIframe = true;
                            console.log('i_outerHTML has ' + '/vendor-invoices?embed=1');
                        }
                    }
                }
                return isIframe;
            }
        }
        catch (ex) {
            console.log('IFRAME' + ex);
        }


        return false;        
    }
    setCookie(name: string, value: string, expireDays: number, path: string = '') {
        let d: Date = new Date();
        d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
        let expires: string = `expires=${d.toUTCString()}`;
        let cpath: string = path ? `; path=${path}` : '';
        document.cookie = `${name}=${value}; ${expires}${cpath}`;
    }    

  }
